export default function () {
    return {
        relatedListings: {
            nearby: [],
        },
        nearbySchools: [],
    };
}
